__webpack_require__.p = "/obenseuer-manager/";